import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

const BedboardPage = loadable(
  () => import('@/pages/CRM/Bedboard/BedboardPage')
); // prettier-ignore

export enum CRMBedboardRoutes {
  CRMBedboard = '/crm/bedboard'
}

export const getCRMBedboardRoutes = (): RouteObject[] => {
  return [
    {
      path: CRMBedboardRoutes.CRMBedboard,
      element: <BedboardPage />
    }
  ];
};
